"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.find");

var _betterScroll = _interopRequireDefault(require("better-scroll"));

var _utils = require("../utils");

var _DK = _interopRequireDefault(require("../DK"));

require("./index.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function template(opts) {
  var html = "<div id=".concat(opts.id, " class=\"tinker-mask ").concat(opts.cls, "\">\n        <div class=\"mask\"><div></div></div>\n        <div class=\"body\">").concat(opts.body, "</div>\n      </div>");
  return html;
}
/**
 * 遮罩
 * 参数：
 *  {
 *    id：{String} id，默认使用自动生成的uuid
 *    cls：{String} css，可覆盖样式
 *    body：{String} 内容，显示在遮罩上
 *    canHide：{Boolean} 是否点击遮罩时隐藏，默认false
 *    canScroll：{Boolean} 遮罩区域是否可以滚动，默认false
 *    onMaskClick：{Function} 点击遮罩区域回调
 *    onShow：{Function} 显示时回调，注意回调时显示动画还未执行完
 *    onHide：{Function} 隐藏时回调
 *    onConfirm：{Function} 点击confirm样式回调
 *    onCancel：{Function} 点击cancel样式回调，同时调用hide
 *  }
 *  方法：
 *    show：显示
 *    hide：隐藏
 *    update：
 *      入参：
 *        {
 *          body：{String} 内容，显示在遮罩上
 *        }
 *    destroy：销毁
 */


var Mask =
/*#__PURE__*/
function () {
  function Mask(opts) {
    _classCallCheck(this, Mask);

    var def = {
      id: (0, _utils.getUUID)(),
      cls: '',
      body: '',
      canHide: true,
      canScroll: false,
      onMaskClick: function onMaskClick() {},
      onShow: function onShow() {},
      onHide: function onHide() {},
      onConfirm: function onConfirm() {},
      onCancel: function onCancel() {}
    };
    this.opts = _objectSpread({}, def, opts);
    this.id = this.opts.id;

    this._init();

    this._event();
  }

  _createClass(Mask, [{
    key: "_init",
    value: function _init() {
      (0, _DK.default)('body').append(template(this.opts));
      this.DK = (0, _DK.default)("#".concat(this.id));
      !this.opts.canScroll && new _betterScroll.default(this.DK.find('.mask').el[0], {
        click: true
      });
      this.createTime = Date.now();
    }
  }, {
    key: "_event",
    value: function _event() {
      var _this = this;

      this.DK.on('click', '.mask', function (e) {
        if (_this.opts.canHide) {
          _this.hide();
        }

        _this._maskClick(e);
      });
      this.DK.on('click', '.confirm', function (e) {
        _this._confirm(e);
      });
      this.DK.on('click', '.cancel', function (e) {
        _this._cancel(e);
      });
    }
  }, {
    key: "_maskClick",
    value: function _maskClick(e) {
      this.opts.onMaskClick(e);
    }
  }, {
    key: "_confirm",
    value: function _confirm(e) {
      this.confirm(e);
    }
  }, {
    key: "_cancel",
    value: function _cancel(e) {
      this.opts.onCancel(e);
      this.hide();
      return this;
    }
  }, {
    key: "confirm",
    value: function confirm() {
      var _this$opts;

      var r = (_this$opts = this.opts).onConfirm.apply(_this$opts, arguments);

      if (r !== false) {
        this.hide();
      }

      return this;
    }
  }, {
    key: "show",
    value: function show() {
      var _this2 = this;

      if (Date.now() - this.createTime < 10) {
        (0, _utils.delayFunc)(function () {
          _this2.DK.show();
        }, 0);
      } else {
        this.DK.show();
      }

      this.opts.onShow();
      this.isShow = true;
      return this;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.DK.hide();
      this.opts.onHide();
      this.isShow = false;
      return this;
    }
  }, {
    key: "update",
    value: function update() {
      var body = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      body !== null && this.DK.find('.body').html(body);
      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.DK.remove();
    }
  }]);

  return Mask;
}();

exports.default = Mask;